import { ShieldIcon, SmartphoneIcon } from "../ui/Icons";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/Card";
import { Button } from "../ui/Button";

// Additional simple icons
const AlertTriangleIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 15.5c-.77.833.192 2.5 1.732 2.5z" />
  </svg>
);

const HeartIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
  </svg>
);

const TrendingUpIcon = ({ className = "w-6 h-6" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
  </svg>
);

const problemStats = [
  {
    icon: ShieldIcon,
    stat: "88%",
    description: "of women feel unsafe traveling solo",
    source: "2024 Travel Safety Study"
  },
  {
    icon: AlertTriangleIcon,
    stat: "64%",
    description: "have experienced unwanted attention while traveling alone",
    source: "Solo Female Traveller Network"
  },
  {
    icon: SmartphoneIcon,
    stat: "78%",
    description: "choose destinations based on safety concerns first",
    source: "2024 Travel Research"
  }
];

const solutionBenefits = [
  {
    icon: HeartIcon,
    title: "Knowledge is Power",
    description: "Real reviews from real women travelers who understand your concerns and experiences."
  },
  {
    icon: ShieldIcon,
    title: "Community Protection",
    description: "Verified information you can trust from a network of experienced female travelers."
  },
  {
    icon: TrendingUpIcon,
    title: "Travel with Confidence",
    description: "Make informed decisions about your safety with up-to-date, crowd-sourced intelligence."
  }
];

export const ProblemSolutionSection = ({ onJoinCommunity }) => {
  return (
    <section id="safety" className="section-mobile bg-white">
      <div className="max-w-7xl mx-auto container-mobile">
        {/* Problem Section */}
        <div className="text-center section-gap-mobile">
          <h2 className="mobile-heading-2">
            The Reality of Solo Female Travel
          </h2>
          <p className="mobile-body-text max-w-3xl mx-auto">
            Despite growing interest in solo travel, safety concerns remain a significant barrier for women worldwide.
          </p>
        </div>

        <div className="stats-mobile card-stack-mobile md:grid-cols-3 section-gap-mobile">
          {problemStats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <Card key={index} className="stat-card-mobile text-center border border-red-200 bg-red-50/30">
                <CardHeader>
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-red-600" />
                  </div>
                  <div className="text-4xl font-bold text-red-600 mb-2">{stat.stat}</div>
                  <CardDescription className="text-gray-700 font-medium">
                    {stat.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-gray-500 italic">{stat.source}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Solution Section */}
        <div className="text-center section-gap-mobile">
          <h2 className="mobile-heading-2">
            Our Solution: Community-Driven Safety
          </h2>
          <p className="mobile-body-text max-w-3xl mx-auto">
            SafeSolo Travel connects you with experienced women travelers who share real, verified safety information.
          </p>
        </div>

        <div className="features-mobile card-stack-mobile md:grid-cols-3 section-gap-mobile">
          {solutionBenefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <Card key={index} className="card-mobile text-center border border-teal-200 bg-teal-50/30">
                <CardHeader>
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon className="w-8 h-8 text-teal-600" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-gray-900 mb-2">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            variant="cta"
            size="xl"
            onClick={onJoinCommunity}
            className="btn-mobile transform transition-all duration-300 hover:scale-105"
          >
            Join Our Community
          </Button>
        </div>
      </div>
    </section>
  );
};